
const initState = {
 newTask: 0,
 doneTask: 0,
 newMessage: 0
}

const dashboardReducer = (state = initState, action) =>{
  switch (action.type) {
    case 'GET_DATA' :
      return {...state, phoneEntered: action.payload}
    case 'URI' :
      const newInfo = {...state.information, img_uri: action.payload}
      return {...state, information: newInfo}
    default:{
      return state;
    }
  }
}

export default dashboardReducer;
